<template>
    <section class="bhub-section cockpit-slider">
        <h3>{{ label }}</h3>
        <div class="description">
            <span v-html="description"></span>
        </div>
        <div class="notification is-danger" v-if="showError">
            Bitte schieben Sie den Slider an die gewünschte Stelle.
        </div>
        <div style="display: block; height: 100px" v-if="hasInput">
            <v-chart
                v-if="hasInput"
                :option="chartOptions"
                :init-options="initOptions"
                ref="bar"
                height="100"
                width="900"
            />
        </div>
        <b-field v-if="!hasInput">
            <b-slider
                style="width: 99%; margin-left: 5px;"
                @change="change($event)"
                class="bhub-slider"
                rounded
                size="is-large"
                :min="0"
                :max="100"
                type="none"
                v-model="sliderValue"
            ></b-slider>
        </b-field>
        <div class="columns is-mobile" v-if="likert">
            <div :class="{'transform-slider-option': true, 'column': true, 'has-text-centered': idx>0, 'has-text-right': idx==options.length-1 }" v-for="option,idx in options" :key="option">
                {{ option }}
            </div>
        </div>
        <div class="columns is-mobile" v-else>
            <div :class="{'column': true, 'has-text-centered': idx>0, 'has-text-right': idx==options.length-1 }" v-for="option,idx in options" :key="option">
                <span class="is-hidden-mobile">
                    {{ option }}
                </span>
                <span class="is-hidden-tablet">
                    {{['A','B','C','D'][idx]}}
                </span>
            </div>
        </div>
        <section v-if="!likert" class="is-hidden-tablet">
            <table class="table">
                <tr v-for="option,idx in options" :key="option">
                    <td>{{['A','B','C','D'][idx]}}</td>
                    <td>{{option}}</td>
                </tr>
            </table>
        </section>

    </section>
</template>
<script>
export default {
    props: {
        qid: Number,
        label: String,
        description: String,
        placeholder: String,
        options: Array,
        value: Number,
        values: Array,
        hasError: Boolean,
        startValue: {
            type: Number,
            default: 50
        },
        likert: {type: Boolean, default: false},
    },
    data() {
        return {
            loaded: false,
            sliderValue: this.startValue,
            showError: this.hasError,
            hasInput: false,

            initOptions: {
                renderer: "svg",
            },
        };
    },
    watch: {
        hasError(v) {
            this.showError = v
        }
    },

    methods: {
        change() {
            this.showError = false
            this.hasInput = true
            this.$emit("input", this.sliderValue)
        },
    },
    computed: {
        chartOptions() {
            let sl = this.sliderValue
            let myValues = []
            this.values.forEach(function(value, i) {
                if (i == sl) {
                    myValues.push({
                        value: value+1,
                        itemStyle: { color: "#6CCEC4" },
                    });
                } else {
                    myValues.push({
                        value: value,
                        itemStyle: { color: "#1469A1" },
                    });
                }
            })
            return {
                grid: {
                    left: 0,
                    top: 0,
                    right: 0,
                    bottom: 0,
                },

                xAxis: {
                    show: false,
                    type: "category",
                },

                yAxis: {
                    show: false,
                    type: "value",
                },
                series: [
                    {
                        data: myValues,
                        type: "bar",
                        smooth: true

                    },
                ],
            };
        },
    },
};
</script>
<style lang="scss">
.bhub-slider .b-slider-thumb {
    background: #1d6fa5 !important;
}
@media only screen and (max-width: 400px) {
    .transform-slider-option {
        font-size: 12px;
    }
}
.cockpit-slider h3{
    padding-bottom: 16px !important;

}
</style>
